import React from 'react';
import ContentfulDialog from '../../../../components/common/ContentfulDialog';
import useSWRImmutable from 'swr/immutable'
import { Legal } from '@brand';

const fetcher = (url:string) => fetch(url).then(res => res.json())

const PrivacyModal = (): JSX.Element => {
  const { data, error } = useSWRImmutable(`api/content?id=${Legal.privacyEntryId}`, fetcher)

  if (error) return <div>Failed to load</div>
  if (!data) return <div>Loading...</div>
  
  return (
    <ContentfulDialog buttonText={data?.fields.buttonText} title={data?.fields.modalTitle} content={data?.fields.modalContent} url={data?.fields.url}></ContentfulDialog>
  );
};

export default PrivacyModal;
